module.exports = __webpack_public_path__ + "img/pic_explain01@2x.2f484442.png";